/* eslint-disable prettier/prettier */
import React from 'react';
import { Row, Col, UncontrolledTooltip } from 'reactstrap';

import { acessoPermitido } from '../../../../../../acessos.seguranca';
import * as acessos from '../../../../../../acessos.const.util';
import IntlMessage from '../../../../../../helpers/intlMessage';

function Item({ item, icone, id, apagar, detalhes, usuario }) {
	return (
		<div className='arquivamento'>
			<Row style={{ marginTop: '16px', width: '100%' }}>
				<Col style={{ marginTop: '-10px' }}>
					<p style={{ fontSize: '16px', fontWeight: 600, marginBottom: '2px' }}>
						{item.numeroMaterial}
					</p>
					<p
						id={`descricaoMaterial_${id}`}
						style={{ fontSize: '14px', marginBottom: 0 }}
					>
						<strong><IntlMessage id="general.materialArchiving.material" />: </strong>
						{item.descricaoMaterial && item.descricaoMaterial.slice(0, 25)}
						{item.descricaoMaterial &&
							item.descricaoMaterial.length > 25 &&
							'...'}
						{item.descricaoMaterial && item.descricaoMaterial.length > 25 && (
							<UncontrolledTooltip
								placement="top"
								target={`descricaoMaterial_${id}`}
							>
								{item.descricaoMaterial}
							</UncontrolledTooltip>
						)}
					</p>
					<p
						id={`paciente_${id}`}
						style={{ fontSize: '14px', marginBottom: '2px' }}
					>
						<strong><IntlMessage id="general.materialArchiving.patient" />: </strong>
						{item.paciente}
						<UncontrolledTooltip placement='top' target={`paciente_${id}`}>
							{item.paciente}
						</UncontrolledTooltip>
					</p>
					{item.pacienteNomeSocial &&
						<p
							id={`nomesocial_${id}`}
							style={{ fontSize: '14px', marginBottom: '2px' }}
						>
							<strong><IntlMessage id="general.materialArchiving.socialName" />: </strong>
							{item.pacienteNomeSocial}
							<UncontrolledTooltip placement='top' target={`nomesocial_${id}`}>
								{item.pacienteNomeSocial}
							</UncontrolledTooltip>
						</p>}
					<p>
						<strong><IntlMessage id="general.materialArchiving.technician" />: </strong>
						{item.nomeTecnico}
					</p>
				</Col>
				<div className="menu-right">
					<div>
						<div
							id={`dataArquivamento_${id}`}
							className="badge badge-info"
							style={{ fontSize: '10px', marginBottom: '5px' }}
						>
							{item.dataArquivamento}
							<UncontrolledTooltip
								placement="top"
								target={`dataArquivamento_${id}`}
							>
								<IntlMessage id="general.materialArchiving.filingDate" />
							</UncontrolledTooltip>
						</div>
						<div className="menu-card-right">
							{acessoPermitido(
								usuario,
								acessos.CancelamentoArquivamentoBlocosELaminas
							) && (
									<i
										id={`cancelar_${id}`}
										style={{ marginRight: '8px' }}
										className="fas fa-trash-alt"
										onClick={() => apagar(item)}
										aria-hidden="true"
									>
										<UncontrolledTooltip placement="top" target={`cancelar_${id}`}>
											<IntlMessage id="general.materialArchiving.cancel" />
										</UncontrolledTooltip>
									</i>
								)}
							<i
								id={`detalhes_${id}`}
								style={{ marginLeft: '10px' }}
								className="fas fa-search"
								onClick={() => detalhes(item)}
								aria-hidden="true"
							>
								<UncontrolledTooltip placement="top" target={`detalhes_${id}`}>
									<IntlMessage id="general.materialArchiving.details" />
								</UncontrolledTooltip>
							</i>
						</div>
						<i
							onClick={() => detalhes(item)}
							id={`tipo_${id}`}
							className={`${icone} fa-2x`}
							style={{
								color: '#3076a8',
								fontSize: '1.5em',
							}}
							aria-hidden="true"
						>
							<UncontrolledTooltip placement="top" target={`tipo_${id}`}>
								{item.tipoNome}
							</UncontrolledTooltip>
						</i>
					</div>
				</div>
			</Row>
		</div>
	);
}

export default Item;



// WEBPACK FOOTER //
// ./src/pages/arquivamento/tabs/Arquivamento/Kamban/Item/index.jsx